import type { TOC } from '@ember/component/template-only';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

const ClientsLoadingRouteTemplate: TOC<object> = <template>
	<SkeletonScreenComponent @type="table" />
</template>;

export default ClientsLoadingRouteTemplate;
